import { usesMobileApp } from "@shared/roles.js";
import type { BootstrapResponse } from "@/lib/types/session";

/**
 * Wo eine aufgelöste Sitzung hingehört — die eine Stelle für diese Frage.
 *
 * Bis S4.1 stand die Zuordnung zweimal da: als `homeFor` in `app/router.tsx`
 * (für `/` und die Login-Seite bei bestehender Sitzung) und noch einmal
 * ausgeschrieben im Submit-Handler von `routes/LoginPage.tsx`. Beide liefen
 * beim ersten Zusatz auseinander — der Fahrer landete nach dem Login weiterhin
 * auf der Büro-Startseite, obwohl der Root-Verweis ihn längst auf seinen Tag
 * schickte.
 *
 * `mustChangePassword` gilt für Bearbeiter und — seit S1.6 — für Mitglieder:
 * deren Erstpasswort stammt aus dem Onboarding-Wizard und wird auf Papier
 * übergeben. Kunden kennen das Flag in der Sitzungsnutzlast nicht.
 */
export function homeFor(session: NonNullable<BootstrapResponse["session"]>): string {
  if (session.actorType === "admin") {
    return session.user.mustChangePassword ? "/change-password" : "/admin";
  }
  if (session.actorType === "member" && session.mustChangePassword) return "/change-password";
  // Wer eine Mobile-Lizenz trägt, landet direkt auf seinem Tag (S4.1): die
  // Mandanten-Startseite darunter besteht aus Büro-Verweisen — Dispoboard,
  // Auftragsliste, Stammdatenpflege —, mit denen ein Fahrer nichts anfängt.
  // Über das Logo bleibt sie erreichbar, wichtig für die Wechselrolle
  // „Bearbeiter/Disponent".
  if (session.actorType === "member") return usesMobileApp(session.role) ? "/app/heute" : "/app";
  return "/onboarding/willkommen";
}
